var tmAuthModalSubtitleWrapper = $('.c-auth-component-description');
var loginSignupWithFbBtnEl = $('[data-social-auth="facebook"]');
var loginSignupWithGoogleBtnEl = $('[data-social-auth="google"]');
var loginSignupWithAppleBtnEl = $('[data-social-auth="apple"]');
var tmAccountEmailFieldWrapper = $('.tm-account-email-div');
var tmAccountEmailFieldEl = $('.tm-account-email');
var tmAccountActionBtnEl = $('.tm-account-action-btn');
var tmAccountErrorMessageLineEl = $('.tm-account-error-message-line');
var tmAuthSocialButtonsWrapper = $('.c-auth-component .c__social__buttons');
var tmAuthSocialHrEl = $('.c-auth-component .c-hr');

tmAuth = function () {
    return {
        currentAuthFlow: 'initial',
        authWaitingCheckoutRedirectUrl: null,
        waitingForCheckoutRedirect: false,
        tmLoggedInUserData: {},
        visitorEmailFieldValue: '',

        triggerUpdateUserData: function () {
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "tm_blog_logged_in_user_data",
                    "tmv_identifier" : tmVisitorStore.getDetail('identifier'),
                },
                success ( returnJSON ) {
                    if (returnJSON.hasOwnProperty('tmUserData')) {
                        tmAuth.tmLoggedInUserData = returnJSON.hasOwnProperty('tmUserData') ? returnJSON.tmUserData : {} ;
                        jQuery(document).trigger('tmBlogUserLoginStatusChanged', { customerOrVisitorWishlists : returnJSON.customerOrVisitorWishlists ?? [] });
                    }
                }
            })
        },

        triggerTmLoginForSocialMedia: function (socialType = '', data = {}) {
            tmAuth.authShowHideLoader(socialType, true);
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "login_to_blog_via_social_media",
                    "social_type": socialType,
                    "fb_access_token": data.hasOwnProperty('fb_access_token') ? data.fb_access_token : '',
                    "google_credential": data.hasOwnProperty('google_credential') ? data.google_credential : '',
                    "apple_code": data.hasOwnProperty('apple_code') ? data.apple_code : '',
                    "apple_id_token": data.hasOwnProperty('apple_id_token') ? data.apple_id_token : '',
                    "apple_user_response": data.hasOwnProperty('apple_user_response') ? data.apple_user_response : [],
                },
                success ( returnJSON ) {
                    if (tmAuth.waitingForCheckoutRedirect) {
                        redirectToCheckoutPage();
                    }
                    else {
                        if (returnJSON.authSuccess) {
                            if (returnJSON.forceReload) {
                                window.location.reload();
                            }
                            else {
                                tmAuth.tmLoggedInUserData = returnJSON.hasOwnProperty('tmUserData') ? returnJSON.tmUserData : {} ;
                                jQuery(document).trigger('tmBlogUserLoginStatusChanged', { customerOrVisitorWishlists : returnJSON.customerOrVisitorWishlists ?? [] });
                            }
                        }
                        tmAuth.authModalHide();
                        tmAuth.authShowHideLoader(socialType, false);
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    window.location.reload();
                }
            })
        },

        triggerFbLoginSdk: function () {
            try {
                FB.login(function(response) {
                    if (response.hasOwnProperty('authResponse') && response.authResponse && response.authResponse.hasOwnProperty('accessToken')) {
                        tmAuth.triggerTmLoginForSocialMedia('facebook', {'fb_access_token' : response.authResponse.accessToken});
                    }
                }, {scope: 'public_profile,email'});
            } catch (e) {}
        },

        authShowHideLoader: function (whichButton, isLoaderAndDisabled = true) {
            let foundButtonEl = null;
            if (whichButton === 'facebook') {
                foundButtonEl = loginSignupWithFbBtnEl;
            }
            else if (whichButton === 'google') {
                foundButtonEl = loginSignupWithGoogleBtnEl;
            }
            else if (whichButton === 'apple') {
                foundButtonEl = loginSignupWithAppleBtnEl;
            }
            else if (whichButton === 'actionButton') {
                foundButtonEl = tmAccountActionBtnEl;
            }

            if (foundButtonEl && isLoaderAndDisabled) {
                tmAuth.authModalOverlay(false)
                tmUtils.showLoaderForSelector(foundButtonEl);
                foundButtonEl.attr('disabled', true);
            }
            if (foundButtonEl && !isLoaderAndDisabled) {
                tmAuth.authModalOverlay(true)
                tmUtils.hideLoaderForSelector(foundButtonEl);
                foundButtonEl.attr('disabled', false);
            }
        },

        authModalOverlay: function (toHide = true) {
            try {
                if (toHide) {
                    window.tmAuthModal.hideOverlay();
                }
                else {
                    window.tmAuthModal.showOverlay();
                }
            } catch (e) {}
        },

        authModalHide: function () {
            try {
                window.tmAuthModal.close();
            } catch (e) {}
        },

        renderAuthFlow: function () {
            tmAuthSocialHrEl.removeClass('c-hidden');
            tmAuthModalSubtitleWrapper.removeClass('c-hidden');
            tmAccountEmailFieldWrapper.removeClass('c-hidden');
            tmAccountEmailFieldEl.removeAttr('disabled');
            tmAccountActionBtnEl.removeClass('c-hidden').find("span").text('Continue with email');
            tmAuthSocialButtonsWrapper.removeClass('c-hidden');
            try {
                window.tmAuthModal.setTitle('Log in or sign up');
                window.tmAuthModal.allowCloseOnBody();
                window.tmAuthModal.showCloseIcon();
            } catch (e) {}
            if (tmAuth.currentAuthFlow === 'widgetPreCheckout'){
                try {
                    window.tmAuthModal.setTitle('Choose an option');
                    window.tmAuthModal.doNotAllowCloseOnBody();
                    window.tmAuthModal.hideCloseIcon();
                } catch (e) {}
                tmAccountErrorMessageLineEl.text('').addClass('c-hidden');
                tmAccountEmailFieldWrapper.addClass('c-hidden');
                tmAuthModalSubtitleWrapper.addClass('c-hidden');
                tmAccountActionBtnEl.find("span").text('Checkout as guest');
                tmAccountActionBtnEl.attr('data-action', 'tm-checkout-as-guest');
            }
            else if (tmAuth.currentAuthFlow === 'magic-login-link-sent') {
                tmAccountActionBtnEl.addClass('c-hidden');
                tmAuthSocialHrEl.addClass('c-hidden');
                tmAuthSocialButtonsWrapper.addClass('c-hidden');
                tmAccountEmailFieldEl.attr('disabled', 'disabled');
            }
            else { /* tmAuth.currentAuthFlow === 'initial' */
                tmAccountActionBtnEl.attr('data-action', 'tm-magic-login-link');
            }
        },

        isUserLoggedInToCurrentBlog: function () {
            let tmUserLoggedInCookieValidTill = Cookies.get('tm_user_logged_in');
            let currentTimestampInSeconds = Math.floor(Date.now() / 1000);
            return !!(tmUserLoggedInCookieValidTill && tmUserLoggedInCookieValidTill > 0 && tmUserLoggedInCookieValidTill > currentTimestampInSeconds);
        },

        updateNavMenuIfBlogUserLoggedIn: function () {
            let avatarIconEl = jQuery('.c-avatar-container .c-avatar-dropdown .c-user-circle .fa-circle-user');
            let userImageEl = jQuery('.c-avatar-container .c-avatar-dropdown .c-user-circle .c-user-circle-image');
            if (tmAuth.isUserLoggedInToCurrentBlog()) {
                let avatarImageShown = false;
                if (tmAuth.tmLoggedInUserData.hasOwnProperty('profile_pic') && tmAuth.tmLoggedInUserData.profile_pic.length > 0) {
                    tmUtils.isValidImageUrl(tmAuth.tmLoggedInUserData.profile_pic, function (isValid) {
                        if (isValid) {
                            userImageEl.find('img').attr('src', tmAuth.tmLoggedInUserData.profile_pic);
                            tmUtils.hideElementsForSelector(avatarIconEl);
                            tmUtils.showElementsForSelector(userImageEl);
                            avatarImageShown = true;
                        }
                    });
                }
                if (!avatarImageShown) {
                    tmUtils.showElementsForSelector(avatarIconEl);
                    tmUtils.hideElementsForSelector(userImageEl);
                }
                tmUtils.hideElementsForSelector(jQuery('[data-on-login="hide"]'));
                tmUtils.showElementsForSelector(jQuery('[data-on-login="show"]'));
            }
            else {
                tmUtils.hideElementsForSelector(jQuery('[data-on-login="show"]'));
                tmUtils.showElementsForSelector(jQuery('[data-on-login="hide"]'));
            }
        },

        triggerTmAccountSubmitBtn: function () {
            tmAccountErrorMessageLineEl.text('').addClass('c-hidden');
            let action = tmAccountActionBtnEl.attr('data-action');
            let emailValidateRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (action === 'tm-magic-login-link') {
                let isValidEmail = emailValidateRegex.test(tmAuth.visitorEmailFieldValue);
                if (isValidEmail) {
                    tmAuth.sendMagicLoginLink(tmAuth.visitorEmailFieldValue);
                }
                else {
                    tmAccountEmailFieldEl.addClass('danger');
                }
            }
            else if (action === 'tm-checkout-as-guest') {
                if (tmAuth.waitingForCheckoutRedirect) {
                    tmAuth.authShowHideLoader('actionButton', true);
                    redirectToCheckoutPage();
                }
                else {
                    try {
                        tmAuth.authModalHide();
                    } catch (e) {}
                }
            }
        },

        sendMagicLoginLink: function (email) {
            tmAuth.authShowHideLoader('actionButton', true);
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "tm_email_send_magic_login_link",
                    "email": email,
                    "tmNonce": tmUtils.getAjaxRequestNonce(),
                },
                success ( returnJSON ) {
                    if (returnJSON.errorMessage.length > 0) {
                        tmAccountErrorMessageLineEl.text(returnJSON.errorMessage).removeClass('c-hidden');
                    }
                    else {
                        tmAccountErrorMessageLineEl.text('We’ve sent you a link that will let you log in without any password.').removeClass('c-hidden');
                    }
                    tmAuth.authShowHideLoader('actionButton', false);
                    tmAuth.currentAuthFlow = 'magic-login-link-sent';
                    tmAuth.renderAuthFlow();
                },
                error(jqXHR, textStatus, errorThrown) {
                    window.location.reload();
                }
            })
        },
    }
}(window);


jQuery(document).ready(function () {
    tmAuth.updateNavMenuIfBlogUserLoggedIn();
});

jQuery(document).on('tmBlogUserLoginStatusChanged', function (e, data) {
    if (
        typeof tmBlogRequestJsVars !== null
        && tmBlogRequestJsVars.hasOwnProperty('custom_page_data')
        && tmBlogRequestJsVars.custom_page_data.hasOwnProperty('is_custom_page')
        && tmBlogRequestJsVars.custom_page_data.hasOwnProperty('custom_page_type')
        && (
            tmBlogRequestJsVars.custom_page_data.custom_page_type === 'login'
            || tmBlogRequestJsVars.custom_page_data.custom_page_type === 'signup'
        )
        && tmAuth.isUserLoggedInToCurrentBlog()
    ) {
        window.location.reload();
    }
    else {
        tmAuth.updateNavMenuIfBlogUserLoggedIn();
    }
});

loginSignupWithFbBtnEl.click(function () {
    tmAuth.triggerFbLoginSdk();
});

/* Create hidden google login button and bind click event to our custom button */
const createHiddenGoogleWrapper = () => {
    try {
        const googleLoginWrapper = document.createElement("div");
        googleLoginWrapper.style.display = "none";
        googleLoginWrapper.classList.add("custom-google-button");
        document.body.appendChild(googleLoginWrapper);
        window.google.accounts.id.renderButton(googleLoginWrapper, {
            type: "icon",
            width: "200",
        });
        const googleLoginWrapperButton = googleLoginWrapper.querySelector("div[role=button]");
        return {
            click: () => {
                if (googleLoginWrapperButton !== null) {
                    googleLoginWrapperButton.click();
                }
            },
        };
    } catch (e) {}
};
loginSignupWithGoogleBtnEl.click(function () {
    const googleButtonWrapper = createHiddenGoogleWrapper();
    googleButtonWrapper.click();
});

function loginWithGoogleCredentialResponse(googleResponse) {
    if (googleResponse.credential) {
        tmAuth.triggerTmLoginForSocialMedia('google', {'google_credential' : googleResponse.credential});
    }
}

loginSignupWithAppleBtnEl.click(function (e) {
    try {
        AppleID.auth.signIn()
    } catch (e) {}
});

try {
    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
        if (event.detail.authorization) {
            tmAuth.triggerTmLoginForSocialMedia('apple', {'apple_code' : event.detail.authorization.code ?? null, 'apple_id_token' : event.detail.authorization.id_token ?? null, 'apple_user_response': event.detail.user ?? []});
        }
    });
    document.addEventListener('AppleIDSignInOnFailure', (event) => {
    });
} catch (e) {}

tmAccountActionBtnEl.click(function (e) {
    e.preventDefault();
    tmAuth.triggerTmAccountSubmitBtn();
});

$(document).on('input', '.tm-account-email' , function () {
    tmAuth.visitorEmailFieldValue = $(this).val();
    tmAccountEmailFieldEl.val(tmAuth.visitorEmailFieldValue);
    if (tmAuth.visitorEmailFieldValue.length > 0) {
        tmAccountEmailFieldEl.removeClass('empty').removeClass('danger')
    }
    else {
        tmAccountEmailFieldEl.addClass('empty');
    }
});

jQuery(document).on('tmWidgetHandleCheckoutRedirect', function (e, data) {
    tmAuth.authWaitingCheckoutRedirectUrl = data.redirectTo;
    try {
        posthog.capture('checkout_initiated', {
            checkout_id: data.checkoutId ?? null
        })
    } catch (e) {}

    if (
        (typeof tmBlogRequestJsVars !== 'undefined' && tmBlogRequestJsVars.hasOwnProperty('tm_blog_id') && tmBlogRequestJsVars.tm_blog_id === 7)
        && window.tmAuthModal !== undefined
        && !tmAuth.isUserLoggedInToCurrentBlog()
    ) {
        tmAuth.currentAuthFlow = 'widgetPreCheckout';
        tmAuth.renderAuthFlow();
        window.tmAuthModal.open();
        tmAuth.waitingForCheckoutRedirect = true
    }
    else {
        redirectToCheckoutPage();
    }
});

function redirectToCheckoutPage() {
    if (tmAuth.authWaitingCheckoutRedirectUrl !== null) {
        window.location.href = tmAuth.authWaitingCheckoutRedirectUrl;
    }
}

jQuery(document).ready(function () {
    if (jQuery('#c-auth-modal').length > 0) {
        window.tmAuthModal = Modal.add("#c-auth-modal");
    }
    tmAuth.renderAuthFlow();
    tmAuth.triggerUpdateUserData(); /* loading for all logged in or not logged-in users as wishlists are allowed to both. */
});

jQuery(document).on('tmModal_closed_#c-auth-modal', function () {
    try {
        if (tmAuth.waitingForCheckoutRedirect) {
            redirectToCheckoutPage();
        }
    } catch (e) {}
});

/*jQuery(document).on('tmModal_open_#c-auth-modal', function () {
    tmAuth.renderAuthFlow();
});*/
